import { AlpineComponent } from 'alpinejs';

const Header = ({ animated = false }): AlpineComponent => ({
  scrolled: false,

  init() {
    if (!animated) return;

    if (window.scrollY > 20) this.scrolled = true;

    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY > 20) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      false
    );
  }
});

export default Header;
